/* eslint-disable arrow-body-style */
/* eslint-disable function-paren-newline */
import { merge } from 'lodash'
import dayjs from 'dayjs/esm'
import localeData from 'dayjs/esm/plugin/localeData'
import minMax from 'dayjs/esm/plugin/minMax'
import LocalizedFormat from 'dayjs/esm/plugin/localizedFormat'
import cn from 'dayjs/esm/locale/zh-cn'
import { chunk, range } from './arrayUtils'

dayjs.extend(localeData)
dayjs.extend(LocalizedFormat)
dayjs.extend(minMax)
dayjs.locale('beer-cn', merge({}, cn, {
  formats: {
    l: 'YYYY-M-D',
    L: 'YYYY-MM-DD',
  },
}))
dayjs.locale('beer-cn')

export {
  dayjs,
}

export const formatTimeObj = timeObj => {
  if (!timeObj) {
    return ''
  }
  if (timeObj.hour > -1 || timeObj.minute > -1 || timeObj.second > -1) {
    return dayjs()
      .set('hour', timeObj.hour)
      .set('minute', timeObj.minute)
      .set('second', timeObj.second)
      .format('HH:mm:ss')
  }
  return ''
}

export const formatDateObj = dateObj => {
  if (!dateObj) {
    return ''
  }
  if (dateObj?.format) {
    return dateObj.format('YYYY-MM-DD')
  }
  return dayjs(dateObj).format('YYYY-MM-DD')
}

export const formatDateTimeObj = dtObject => {
  if (!dtObject) {
    return ''
  }
  if (dtObject?.format) {
    return dtObject.format('YYYY-MM-DD HH:mm:ss')
  }
  return dayjs(dtObject).format('YYYY-MM-DD HH:mm:ss')
}

export const getMonthShortLocale = v => dayjs()
  .localeData()
  .monthsShort(dayjs().month(v))

export const getMonthShort = () => range(0, 12)
  .map(getMonthShortLocale)

export const getWeekDays = () => range(7)
  .map(v => dayjs()
    .localeData()
    .weekdaysMin(dayjs().day(v)),
  )

export const getDayMatrix = (year, month) => {
  const date = dayjs()
    .year(year)
    .month(month)

  const startOfMonth = date.startOf('month').date()
  const endOfMonth = date.endOf('month').date()

  const startDay = date.startOf('month').day()
  const remain = (startDay + endOfMonth) % 7
  const lastMonthEndDate = date.subtract(1, 'month').endOf('month').date()

  return chunk(
    [
      ...range(lastMonthEndDate - startDay + 1, lastMonthEndDate + 1).map(v => `${v}`),
      ...range(startOfMonth, endOfMonth + 1).map(v => `${v}`),
      ...(7 - remain === 7 ? [] : range(1, 7 - remain + 1).map(v => `${v}`)),
    ],
    7,
  )
}

export const getMonthMatrix = () => {
  return chunk(getMonthShort(), 4)
}

export const getYearMatrix = year => {
  return chunk(range(year - 6, year + 6).map(v => `${v}`), 4)
}

export const isDayEqual = (day1, day2) => {
  if (!day1 || !day2) return false
  return dayjs(day1).isSame(day2, 'date')
}

export const isDayAfter = (day1, day2) => {
  return dayjs(day1).isAfter(day2, 'date')
}

export const isDayBefore = (day1, day2) => {
  return dayjs(day1).isBefore(day2, 'date')
}

export const isDayRange = (date, start, end) => {
  if (!start || !end) return false

  return isDayAfter(date, start) && isDayBefore(date, end)
}

export const formatDate = (date, format) => {
  if (date === undefined) return ''
  return dayjs(date).format(format)
}
